import { useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Header";

export const AuthModal = () => {
  const { authOpen, setAuthOpen, authTab, setAuthTab, signIn } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const isReg = authTab === "register";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const body = { username, password };
      if (isReg) body.ref = localStorage.getItem("xver_ref") || undefined;
      const { data } = await api.post(isReg ? "/auth/register" : "/auth/login", body);
      signIn(data.token, data.user);
      toast.success(isReg ? "Hoş geldin! Hesabın oluşturuldu" : "Giriş başarılı");
      setAuthOpen(false);
      setPassword("");
    } catch (err) {
      setError(errMsg(err));
    }
    setLoading(false);
  };

  return (
    <Dialog open={authOpen} onOpenChange={setAuthOpen}>
      <DialogContent data-testid="auth-modal" className="bg-[var(--x-bg)] border-[var(--x-border)] max-w-md p-0 overflow-hidden">
        <div className="p-6 pb-0">
          <Logo />
          <DialogTitle className="mt-4 text-xl font-extrabold">{isReg ? "Hesap Oluştur" : "Giriş Yap"}</DialogTitle>
          <DialogDescription className="text-[var(--x-muted)] text-sm mt-1">
            {isReg ? "Benzersiz bir kullanıcı adı seç ve oynamaya başla." : "Hesabına giriş yaparak oyuna devam et."}
          </DialogDescription>
        </div>
        <div className="mx-6 mt-5 grid grid-cols-2 bg-[var(--x-bg-deep)] rounded-full p-1">
          {["login", "register"].map((t) => (
            <button
              key={t}
              data-testid={`auth-tab-${t}`}
              onClick={() => { setAuthTab(t); setError(""); }}
              className={`rounded-full py-2 text-sm font-bold transition-colors ${authTab === t ? "bg-[var(--x-panel-2)] text-white" : "text-[var(--x-muted)]"}`}
            >
              {t === "login" ? "Giriş Yap" : "Kayıt Ol"}
            </button>
          ))}
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div>
            <label className="x-label">Kullanıcı Adı {!isReg && <span className="text-[var(--x-dim)]">veya e-posta</span>}</label>
            <input data-testid="auth-username-input" className="x-input" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
          </div>
          <div>
            <label className="x-label">Şifre</label>
            <div className="relative">
              <input
                data-testid="auth-password-input"
                type={show ? "text" : "password"}
                className="x-input pr-11"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete={isReg ? "new-password" : "current-password"}
                required
              />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--x-muted)]">
                {show ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          {error && <div data-testid="auth-error" className="text-sm font-semibold text-[var(--x-red)]">{error}</div>}
          <button data-testid="auth-submit-btn" disabled={loading} className="x-btn x-btn-primary w-full py-3.5">
            {loading && <Loader2 size={18} className="animate-spin" />}
            {isReg ? "Kayıt Ol" : "Giriş Yap"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
